import * as Label from '@radix-ui/react-label';
import { useId } from 'react';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

// Field's multi-line twin, with the same label, hint and error wiring (INV-13): for text a person
// writes in lines — an address, payment details, terms.

interface TextAreaProps extends Omit<ComponentPropsWithoutRef<'textarea'>, 'id'> {
  readonly label: string;
  readonly hint?: ReactNode;
  readonly error?: string | undefined;
}

export function TextArea({ label, hint, error, rows = 3, ...area }: TextAreaProps) {
  const id = useId();
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const describedBy = [hint ? hintId : null, error ? errorId : null].filter(Boolean).join(' ');

  return (
    <div className="flex flex-col gap-1.5">
      <Label.Root htmlFor={id} className="text-xs text-ink-soft">
        {label}
      </Label.Root>
      {hint ? (
        <p id={hintId} className="text-xs text-muted">
          {hint}
        </p>
      ) : null}
      <textarea
        id={id}
        rows={rows}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy || undefined}
        className="input min-h-0 py-2"
        {...area}
      />
      {error ? (
        <p id={errorId} className="text-sm font-semibold text-accent-2-700">
          {error}
        </p>
      ) : null}
    </div>
  );
}
